module.exports = __webpack_public_path__ + "assets/img/home_s_i4.0153255b.png";